import api from "src/spintr/SpintrApi";

const baseUrl = "/api/v1/shortcuts";

export const queryUserShortcuts = () =>
    api.get<Spintr.IShortcut[]>(baseUrl);
